// extracted by mini-css-extract-plugin
module.exports = {"containerClass":"LandingPage_containerClass__pa-Nh","containerHeadingClass":"LandingPage_containerHeadingClass__2FYaa"};